import { NgModule } from '@angular/core';
import { MissingPropertyDirective } from './missing-property.directive';
import { PreventKeyseDirective } from './preventKeyseDirective.directive';
import { DisableButtonsOnRole } from './disable-on-role';
import { DndDirective } from './dnd.directive';
import { ShowTooltipWhenEllipsisActiveDirective } from './showTooltipWhenEllipsisActive.directive';

@NgModule({
    declarations: [MissingPropertyDirective, PreventKeyseDirective, DisableButtonsOnRole, DndDirective, ShowTooltipWhenEllipsisActiveDirective],
    imports: [],
    exports: [MissingPropertyDirective, PreventKeyseDirective, DisableButtonsOnRole, ShowTooltipWhenEllipsisActiveDirective],
})
export class DirectivesModule {}
